/**
 * Driver Themes ticket — shared vertex shader.
 *
 * Single full-screen triangle-pair quad. All visual work happens in
 * the fragment stage. Used by all three fragment programs (orb
 * composite, obsidian, neon) without modification; the WebGL setup
 * helpers in Commit 6 compile this once per shaderKind and link it
 * against the appropriate fragment shader.
 *
 * GLSL ES 3.00 — required to match the fragment shaders' `#version
 * 300 es` directive (WebGL2 baseline).
 */
export const VERTEX_SHADER_SOURCE = `#version 300 es
in vec2 aPos;
void main() {
  gl_Position = vec4(aPos, 0.0, 1.0);
}`;
